import tableBarsGamesMapping from '../../../tableBarsGamesMappings';
/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class BundleParser {

    static defaultLang = 'en';

    static langsMapping = {
        cf: 'fr-CA'
    }

    static CDN_MAP = {
        'dev': 'https://cdn.dopamine-gaming.com/dev/',
        'production': 'https://cdn-eu.cloudedge.info/all/'
    }

    static parseLaunch(launcherConfig, cfg) {
        this.omnibarPath = launcherConfig.omnibarPath;

        this.bundlerGameId = launcherConfig.gameSettings ?
            launcherConfig.gameSettings.source : null;

        return cfg;
    }

    static parse(cfg, settings, options) {
        // TODO get cdn from settings
        let cdn = BundleParser.CDN_MAP[options.urlParams.environment || 'production'];
        let assetsPath = `${cdn}games/assets/`;
        let localizationsPath = `${cdn}games/localizations/`;
        let forceResolution = 'MD';

        const { jackpotPanel, jackpotWheel, gamble, bonus, widgets } = cfg;
        let corePath = cfg.bridge.provider === 'stars' ? `${cfg.bridge.cdn}gameloader` : `${cfg.bridge.cdn}core`;

        let gamePath = this.bundlerGameId ?
            `${cfg.bridge.cdn}games.${this.bundlerGameId}` :
            `${cfg.bridge.cdn}games.${cfg.server.launchParams.gameId}`;

        let gameName = this.bundlerGameId ? this.bundlerGameId : cfg.server.launchParams.gameId;

        let lang = cfg.server.launchParams.userData.lang;

        if ( lang ) {
            if (!['zh-TW', 'es-PE', 'pt-BR', 'fr-CA'].includes(lang)) {
                lang = lang.substr(0, 2);
            }
        } else {
            console.warn(`[bridge] #BundleParser: unsupported lang ${lang}, falling back to 'en'!`);
            lang = 'en';
        }

        const { isBundlerV2Build, assetsCDN } = com.casino && com.casino.bundler || {};

        if (lang && BundleParser.langsMapping.hasOwnProperty(lang)) {
            lang =  BundleParser.langsMapping[lang];
        }

        cfg.bars.basePath = isBundlerV2Build ? `${assetsCDN}/games.bars-next/` : options.urlParams.barsURL || `${corePath}/games.bars-next/`;

        this.isBarsMapped = tableBarsGamesMapping.some(item => cfg.server.launchParams.gameId.toLowerCase().startsWith(item.toLowerCase()));

        if (this.isBarsMapped){
            cfg.bars.basePath = cfg.bars.basePath.replace('bars-next', 'bars-table');
        }

        cfg.bridge.localizationsPath = localizationsPath;
        cfg.bars.localizationsPath = localizationsPath;
        cfg.bars.options.historySrc = `${corePath}/games.history/`;
        cfg.bars.assetsPath = assetsPath;
        cfg.game.preconfig.cdn = isBundlerV2Build ? `${assetsCDN}/games.${gameName}.${lang}/` : `${gamePath}.${lang}/`;
        cfg.game.preconfig.forceResolution = forceResolution;
        cfg.game.preconfig.gameAppId = cfg.server.launchParams.gameId;
        cfg.game.preconfig.isBundleEnv = true;
        isBundlerV2Build && (cfg.game.preconfig.isBundlerV2Build = true);
        isBundlerV2Build && (cfg.game.preconfig.bundlerGameId = this.bundlerGameId);

        if (options.isCayetano) {
            let omnibarPath = this.omnibarPath || `${corePath}/games.omnibar/`;
            cfg.game.preconfig.cdn = `${gamePath}/`;
            cfg.game.preconfig.dependencies = {
                game: `${gamePath}/`,
                lang: `${gamePath}.${lang}/`,
                omnibar: omnibarPath
            };
        }

        if (cfg.widgets) {
            widgets.panel.base = `${corePath}/games.widgets.panel/`;

            const tournaments = cfg.widgets.tournaments;

            if (tournaments) {
                const skin = tournaments.base.match(/widgets\/(.+)\//);
                if (skin && skin[1]) tournaments.base = `${corePath}/games.widgets.${skin[1]}/`;
            }
        }

        if (jackpotWheel) {
            const hasWheel = !options.isCayetano;
            const jackpotWheelSkin = (hasWheel && !jackpotWheel.wheelWinOnly) ? jackpotWheel.skin : 'base-wheel';
            jackpotWheel.cdn = `${gamePath}/`;

            isBundlerV2Build ?
                jackpotWheel.basePath = `${assetsCDN}/games.scenes.jackpot-wheels.${jackpotWheelSkin}/` :
                jackpotWheel.basePath = `${corePath}/games.scenes.jackpot-wheels.${jackpotWheelSkin}/`;
        }

        if (jackpotPanel) {
            isBundlerV2Build ?
                jackpotPanel.basePath = `${assetsCDN}/games.widgets.jackpots.${jackpotPanel.skin}/` :
                jackpotPanel.basePath = `${corePath}/games.widgets.jackpots.${jackpotPanel.skin}/`;
        }

        if (bonus) {
            bonus.basePath = `${corePath}/games.widgets.bonus/`;
            bonus.assetsPath = assetsPath;
            window.com.casino.bonusPath = bonus.basePath;
        }

        if (gamble) {
            isBundlerV2Build ?
                gamble.basePath = `${assetsCDN}/games.gambles.pie/` :
                gamble.basePath = `${corePath}/games.gambles.pie/`;

            window.com.casino.piePath = `${corePath}/games.gambles.pie/`;
        }

        return cfg;
    }
}


module.exports = BundleParser;
